// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementInvalidAttributeNamesResult = objectOf({
  custom_attribute_names: arrayOf(string),
  content_block_names: arrayOf(string),
});
